import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const P = props => <p className="c-vi-p">{props.children}</p>;

P.propTypes = {
  children: PropTypes.node.isRequired,
};

export default P;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/P.jsx